import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MessageService } from 'primeng/api';
import { XpressCodeConductService, XpressDisciplinaryService, RiderService } from 'app/services';
import {
    XpressDisciplinaryStatusModel, XpressDisciplinaryTypeModel,
    XpressOffenseTypeModel, XpressPriorityTypeModel,
    AddOrUpdateDisciplinary, XpressDisciplinaryChannelModel,
    CreateCodeConductResponse
} from 'app/models';
import { HomeDisciplinaryComponent } from 'app/home';
import moment from 'moment';
import { CreateCodeConductRequest } from '../../../../models';
import { ResponceErrorCode } from 'XpressTransfer/app/transfer/components/transfer/shared/enums/response-error-code.enum';

@Component({
    selector: 'add-or-update-disciplinary',
    templateUrl: './add-or-update-disciplinary.component.html',
    styleUrls: ['./add-or-update-disciplinary.component.scss',
        '../../../../../styles/sidebar.scss',
        '../../../../../styles/style-layout.scss'
    ],
    providers: [MessageService]
})
export class AddOrUpdateDisciplinaryComponent implements OnInit {
    @Input() public homeDisciplinaryComponent!: HomeDisciplinaryComponent;

    @Input() public showAddOrUpdateDisciplinarySideBar: boolean = false;

    @Input() public representativeFullName: string = '';

    @Output() changedShowAddOrUpdateDisciplinarySideBarEmit = new EventEmitter<boolean>();
    changedShowAddOrUpdateDisciplinarySideBar(increased: any) {
        this.changedShowAddOrUpdateDisciplinarySideBarEmit.emit(increased);
    }

    public disciplinary!: any;
    public disciplinaryStatuses = XpressDisciplinaryStatusModel.XpressDisciplinaryStatusList;
    public disciplinaryType = XpressDisciplinaryTypeModel.XpressDisciplinaryTypeList;
    public offenseTypes = XpressOffenseTypeModel.XpressOffenseTypeList;
    public priorityTypes = XpressPriorityTypeModel.XpressPriorityTypeList;
    public disciplinaryChannelList = XpressDisciplinaryChannelModel.XpressDisciplinaryChannelList;
    public codeConducts!: any;
    public users!: any;
    @Input() public selectComplaintUser!: any;
    public isCustomerAffected: string = 'false';
    private timer: number = 0;
    public loading: boolean = false;
    private isCodeConductSelected: boolean = false;
    EVENT_CLICK = 'click';

    constructor(private messageService: MessageService, private disciplinaryService: XpressDisciplinaryService,
        private codeConductService: XpressCodeConductService, private riderService: RiderService) {
        this.disciplinary = new AddOrUpdateDisciplinary();
    }

    ngOnInit(): void {
        this.getCodeConducts();
    }

    public getCodeConducts() {
        this.loading = true;
        const dto = {};
        this.codeConductService.getCodeConducts(dto, this.messageService)
            .then(data => {
                if (!data) {
                    this.loading = false;
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    this.loading = false;
                    return;
                }
                this.codeConducts = data.Items;
                this.loading = false;
            })
            .catch(error => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
            });
    }

    public searchUsers(event: any) {
        const query = event.query;
        if (this.timer) {
            window.clearTimeout(this.timer);
        }
        this.timer = window.setTimeout(() => {
            const dto = {
                Search: query
            };

            this.riderService.searchRiders(dto, this.messageService)
                .then(data => {
                    if (!data) {
                        return;
                    }

                    if (!data.Success) {
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                        return;
                    }
                    this.users = data.Items;
                })
                .catch(error => {
                });
        }, 700);
    }

    public addOrUpdateDisciplinary() {
        const isCheck = this.checkDisciplinaryFields();
        if (isCheck) {
            this.loading = true;
            this.disciplinary.ComplaintUserId = this.selectComplaintUser?.Id;
            this.disciplinary.OffenseDateTime = moment(this.disciplinary.OffenseDateTime).format('YYYY-MM-DDTHH:mm:ss');
            this.disciplinary.IsCustomerAffected = JSON.parse(this.isCustomerAffected);

            if(this.isCodeConductSelected){
                this.saveDisciplinary();
                return;
            }

            this.createNewCodeConduct(this.disciplinary.CodeConductId).then((response: CreateCodeConductResponse) => {
                if(!response.Success && response.ErrorCode !== ResponceErrorCode.RecordExists){
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: response.ErrorMessage });
                    return;
                }
                this.disciplinary.CodeConductId = response.Id;
                this.saveDisciplinary();
            });
        }
    }

    private saveDisciplinary(){
        this.disciplinaryService.addOrUpdateDisciplinary(this.disciplinary, this.messageService)
        .then(data => {
            if (!data) {
                this.loading = false;
                return;
            }
            if (!data.Success) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                this.loading = false;
                return;
            }
            if (this.homeDisciplinaryComponent) {
                this.homeDisciplinaryComponent.getRidersDisciplinaries(0);
            }
            this.cancel();
        }).catch(error => {
            console.log(error);
            this.loading = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
        });
    }

    private checkDisciplinaryFields() {
        const requiredFields = [
            { field: this.disciplinary.PriorityTypeId, message: 'Priority is required field' },
            { field: this.disciplinary.OffenseTypeId, message: 'Offense is required field' },
            { field: this.disciplinary.DisciplinaryTypeId, message: 'Disciplinary Type is required field' },
            { field: this.disciplinary.CodeConductId, message: 'Code is required field' },
            { field: this.selectComplaintUser?.Id, message: 'User is required field' },
            { field: this.disciplinary.OffenseDateTime, message: 'Date Time is required field' },
            { field: this.disciplinary.Channel, message: 'Channel is required field' },
            { field: this.disciplinary.Note, message: 'Note is required field' },
            { field: this.disciplinary.CustomerName, message: 'Customer name is required field' },
            { field: this.disciplinary.CustomerEmail, message: 'Customer email is required field' },
            { field: this.disciplinary.CustomerPhone, message: 'Customer phone is required field' }
        ];

        for (const { field, message } of requiredFields) {
            if (!field) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: message });
                return false;
            }
        }

        return true;
    }

    cancel() {
        this.changedShowAddOrUpdateDisciplinarySideBar(false);
    }

    private createNewCodeConduct(conductId: string): Promise<CreateCodeConductResponse>{
        const request: CreateCodeConductRequest = {
            Code: conductId,
            ProhibitedAct: ''
        };
        return new Promise<CreateCodeConductResponse>((resolve, reject) =>{
            this.codeConductService.createCodeConduct(request, this.messageService).then((response) => {
                resolve(response);
            }, error => {
                reject(error);
            });
        });
    }

    onCodeConductChange(event: any){
        this.isCodeConductSelected = event.originalEvent.type === this.EVENT_CLICK;
        console.log(this.isCodeConductSelected);
    }
}
